export const handleChangeDataCourierOrders = (name, value) => ({
    type: 'CHANGE_DATA_COURIER_ORDERS', name, value
});